export const DATA_BASE_URL =
  'https://my-json-server.typicode.com/obrm/it-logger-db';
